import { formatRoundedNumber } from '@/lib/formatUtils';
import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

interface BottomBarProps {
  so_luong?: number;
  thanh_tien?: number;
  thue?: number;
  tong_tien?: number;
}

function BottomBar({ so_luong = 0, thanh_tien = 0, thue = 0, tong_tien = 0 }: BottomBarProps) {
  return (
    <div className='w-full border-t bg-white px-4 py-2'>
      <div className='flex'>
        <div className='flex flex-col'>
          {/* Column 1 */}
          <div className='flex items-center'>
            <Label className='w-28 font-medium'>Tổng số lượng</Label>
            <div className='w-[100px] pb-1'>
              <FormField name='t_so_luong' type='text' value={formatRoundedNumber(so_luong, 6)} />
            </div>
          </div>
        </div>

        <div className='ml-4 flex flex-col'>
          <div className='flex items-center'>
            <Label className='w-24 font-medium'>Tổng tiền</Label>
            <FormField
              name='t_tien_nt'
              type='text'
              labelClassName='mr-2 font-medium'
              inputClassName='text-right'
              value={formatRoundedNumber(thanh_tien)}
            />
            <FormField
              name='t_tien'
              type='text'
              labelClassName='mr-2 font-medium'
              inputClassName='text-right'
              value={formatRoundedNumber(thanh_tien)}
              className='hidden'
            />
          </div>
          <div className='flex items-center'>
            <Label className='w-24 font-medium'>Tổng thuế</Label>
            <FormField
              name='t_thue_nt'
              type='text'
              labelClassName='mr-2 font-medium'
              inputClassName='text-right'
              value={formatRoundedNumber(thue)}
            />
            <FormField
              name='t_thue'
              type='text'
              labelClassName='mr-2 font-medium'
              inputClassName='text-right'
              value={formatRoundedNumber(thue)}
              className='hidden'
            />
          </div>
        </div>

        <div className='ml-auto flex w-1/4 flex-col'>
          {/* Column 3 */}
          <div className='flex items-center'>
            <Label className='w-32 font-medium'>Tổng thanh toán</Label>
            <FormField
              name='t_tt_nt'
              type='text'
              labelClassName='mr-2 font-medium'
              inputClassName='text-right'
              value={formatRoundedNumber(tong_tien)}
            />
            <FormField
              name='t_tt'
              type='text'
              labelClassName='mr-2 font-medium'
              inputClassName='text-right'
              value={formatRoundedNumber(tong_tien)}
              className='hidden'
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BottomBar;
